import React from 'react';
import PropTypes from 'prop-types';
import NavigationMenu from './components/NavigationMenu';
import { MODES } from './utils';
import { DEFAULT_LOCALE } from './services/localize';
import { withMenuTransformer } from './transformer';

import './index.scss';
import { DEFAULT_CURRENCY } from './constants';

const CategoriesMenu = (props) => (<NavigationMenu {...props}/>);

const CategoriesMenuTransformed = withMenuTransformer(CategoriesMenu);

CategoriesMenu.propTypes = {
    mode: PropTypes.oneOf([MODES.DEFAULT, MODES.PRO]),
    config: PropTypes.object,
    locale: PropTypes.string,
    theme: PropTypes.string,
    shouldPreRender: PropTypes.bool,
    currency: PropTypes.object,
    rollouts: PropTypes.object
};

CategoriesMenu.defaultProps = {
    useCmsConfig: false,
    config: {},
    menuItems: [],
    mode: MODES.DEFAULT,
    locale: DEFAULT_LOCALE,
    shouldPreRender: true,
    currency: DEFAULT_CURRENCY,
    rollouts: {}
};

export default CategoriesMenuTransformed;
